export default __webpack_public_path__ + "static/media/logo-footer.b9baf6ae.png";